import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-friend",
  "use": "icon-friend-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-friend\"><defs><style type=\"text/css\"></style></defs><path d=\"M650.666667 117.333333v256H554.666667v106.666667h288v170.666667h85.333333v234.666666h-234.666667v-234.666666h85.333334v-106.666667h-512v106.666667h85.333333v234.666666h-234.666667v-234.666666h85.333334v-170.666667H490.666667v-106.666667h-96v-256h256z m-362.666667 597.333334h-106.666667v106.666666h106.666667v-106.666666z m576 0h-106.666667v106.666666h106.666667v-106.666666z m-277.333333-533.333334h-128v128h128v-128z\" p-id=\"1853\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/friend.svg
// module id = Dm7T
// module chunks = 80